"use strict";
// DO NOT EDIT. Generated by gitlab.com/accumulatenetwork/accumulate/tools/cmd/gen-types.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TxFetchMode = exports.BlockFilterMode = void 0;
/* eslint-disable @typescript-eslint/no-namespace */
var BlockFilterMode;
(function (BlockFilterMode) {
    /** ExcludeNone return all blocks including empty ones. */
    BlockFilterMode[BlockFilterMode["ExcludeNone"] = 0] = "ExcludeNone";
    /** ExcludeEmpty exclude empty blocks. */
    BlockFilterMode[BlockFilterMode["ExcludeEmpty"] = 1] = "ExcludeEmpty";
})(BlockFilterMode = exports.BlockFilterMode || (exports.BlockFilterMode = {}));
/** @ignore */
(function (BlockFilterMode) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    BlockFilterMode.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "excludenone":
                return BlockFilterMode.ExcludeNone;
            case "excludeempty":
                return BlockFilterMode.ExcludeEmpty;
            default:
                throw new Error(`Unknown BlockFilterMode '${name}'`);
        }
    }
    BlockFilterMode.byName = byName;
    function getName(v) {
        switch (v) {
            case BlockFilterMode.ExcludeNone:
                return "excludeNone";
            case BlockFilterMode.ExcludeEmpty:
                return "excludeEmpty";
            default:
                throw new Error(`Unknown BlockFilterMode ${v}`);
        }
    }
    BlockFilterMode.getName = getName;
})(BlockFilterMode = exports.BlockFilterMode || (exports.BlockFilterMode = {}));
var TxFetchMode;
(function (TxFetchMode) {
    /** Expand expand the full transactions in the result set. */
    TxFetchMode[TxFetchMode["Expand"] = 0] = "Expand";
    /** Ids include the transaction IDs & count in the result set. */
    TxFetchMode[TxFetchMode["Ids"] = 1] = "Ids";
    /** CountOnly only include the transaction count in the result set. */
    TxFetchMode[TxFetchMode["CountOnly"] = 2] = "CountOnly";
    /** Omit omit all transaction info from the result set. */
    TxFetchMode[TxFetchMode["Omit"] = 3] = "Omit";
})(TxFetchMode = exports.TxFetchMode || (exports.TxFetchMode = {}));
/** @ignore */
(function (TxFetchMode) {
    function fromObject(obj) {
        if (typeof obj === "number")
            return obj;
        return byName(obj);
    }
    TxFetchMode.fromObject = fromObject;
    function byName(name) {
        switch (name.toLowerCase()) {
            case "expand":
                return TxFetchMode.Expand;
            case "ids":
                return TxFetchMode.Ids;
            case "countonly":
                return TxFetchMode.CountOnly;
            case "omit":
                return TxFetchMode.Omit;
            default:
                throw new Error(`Unknown TxFetchMode '${name}'`);
        }
    }
    TxFetchMode.byName = byName;
    function getName(v) {
        switch (v) {
            case TxFetchMode.Expand:
                return "expand";
            case TxFetchMode.Ids:
                return "ids";
            case TxFetchMode.CountOnly:
                return "countOnly";
            case TxFetchMode.Omit:
                return "omit";
            default:
                throw new Error(`Unknown TxFetchMode ${v}`);
        }
    }
    TxFetchMode.getName = getName;
})(TxFetchMode = exports.TxFetchMode || (exports.TxFetchMode = {}));
//# sourceMappingURL=enums_gen.js.map